export default __webpack_public_path__ + "images/16d86ed52ad1cc4fa6e0eb00d1794003.svg";